import { Redirect } from 'wouter'
import config from '../config'

export default function IndexScreen() {
  return config.token ? <Redirect to="/home" /> : <Redirect to="/login" />
}
